module.exports = __webpack_public_path__ + "static/item--ac--f9@3x.79d253a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f9@3x.png
// module id = 627
// module chunks = 126511778744290